import React from 'react'
import "../assets/css/notFound.css"
import err from "../assets/images/404.jpg"
function NotFound() {
  return (
    <>
      
      <div className="not-found container ">
       <div className='not-found-content text-center'>
        <div className='mb-2 '>
          <img src={err} alt='404' style={{width:"300px" ,height:"300px"}}/>
        </div>
        <h1 className='text-center '>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
        <div className='text-center'>
          <a href="/" className='btn text-white mt-4' style={{background: "#3C348D"}}>Back to Home</a>
        </div>
       </div>
      </div>
      
    </>
  )
}

export default NotFound

